import { styled } from '../../config'
import { Spinner } from '../Spinner'

const Root = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  background: '$whiteA050',
  overflow: 'hidden',
  borderRadius: '12px',
  borderColor: '$whiteA100',
  borderWidth: '1px',
  borderStyle: 'solid',
  position: 'relative'
})

const Content = styled('div', {
  padding: '16px',
  display: 'flex',
  flexDirection: 'column'
})

const Loader = styled(Spinner, {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
})

const Text = styled('div', {
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '#EDEDED',
  fontSize: '$14',
  variants: {
    type: {
      title: {
        fontWeight: 400,
        fontSize: '$20'
      },
      subtitle: {
        fontWeight: 400,
        fontSize: '$14'
      },
      bold: {
        fontWeight: 500
      },
      muted: {
        fontWeight: 400,
        opacity: '60%'
      }
    },
    noEllipsis: {
      true: {
        whiteSpace: 'normal',
        overflow: 'visible'
      }
    }
  }
})

const Row = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
})

export const Card = { Root, Content, Loader, Text, Row }
